import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  billReport: [],
  saleReport: [],
};

const report = createSlice({
  name: "report",
  initialState,
  reducers: {
    setBillReport: (state, action) => {
      state.billReport = action.payload;
    },
    setSaleReport: (state, action) => {
      state.saleReport = action.payload;
    },
    clearBillReport: (state) => {
      state.billReport = [];
    },
    clearSaleReport: (state) => {
      state.saleReport = [];
    },
  },
});

export const { setBillReport, setSaleReport, clearBillReport, clearSaleReport } = report.actions;

export default report.reducer;
